import React from "react";

export const getResponsiveForGraphFontSize = () => {
  // 0.8vw in pixels
  return Math.round(window.innerWidth * 0.008);
};

const useGraphFontSize = () => {
  const [fontSize, setFontSize] = React.useState(
    getResponsiveForGraphFontSize()
  );

  React.useEffect(() => {
    const handleResize = () => setFontSize(getResponsiveForGraphFontSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return fontSize;
};

export default useGraphFontSize;
